import { render, staticRenderFns } from "./IpServer.vue?vue&type=template&id=3d53ab5c&scoped=true&"
import script from "./IpServer.vue?vue&type=script&lang=js&"
export * from "./IpServer.vue?vue&type=script&lang=js&"
import style0 from "./IpServer.vue?vue&type=style&index=0&id=3d53ab5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d53ab5c",
  null
  
)

export default component.exports